import fetchUserAppToast from './fetchUserAppToast';

export default {
  fetchUserAppToast,
};



// WEBPACK FOOTER //
// ./src/app/services/appToast/index.js